import React from 'react'
import AppLayout from '../components/AppLayout'

const AddBusiness = () => {
  return (
    <AppLayout>
        <div className='flex-1 h-full flex flex-col items-center gap-10 p-10 justify-center'>
        <h1>Add New Business</h1>
        <div className='w-1/2 flex flex-col items-center gap-4'>
        <input placeholder='Business Name'/>
        <input placeholder='Business Category'/>
        <input placeholder='Owner Name'/>
        <input placeholder='Business Email'/>
        <input placeholder='Business Phone'/>
        <input placeholder='Business Address'/>
        <input placeholder='Password'/>
        <input placeholder='Confirm Password'/>
        <button>ADD BUSINESS</button>
        </div>
        </div>
    </AppLayout>
  )
}

export default AddBusiness